import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { ClipboardCheck } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Soft reminder shown on the dashboard when there are completed jobs
// awaiting approval into a weekly report. Non-blocking, hidden at zero.
export default function WeeklyReviewReminder() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API_URL}/api/dashboard/weekly-review/pending-count`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => { if (active) setCount(res.data?.pendingCount || 0); })
      .catch(() => {});
    return () => { active = false; };
  }, [token]);

  if (count <= 0) return null;

  return (
    <div
      className="rounded-md border border-primary/30 bg-primary/5 px-4 py-3 flex items-center justify-between gap-3"
      data-testid="weekly-review-reminder"
    >
      <div className="flex items-center gap-3 min-w-0">
        <ClipboardCheck className="h-5 w-5 text-primary flex-shrink-0" />
        <p className="text-sm">
          <b>{count}</b> completed job{count !== 1 ? 's' : ''} ready to review and turn into a weekly report.
        </p>
      </div>
      <Button size="sm" onClick={() => navigate('/dashboard/weekly-review')}
        data-testid="weekly-review-reminder-btn">
        Review now
      </Button>
    </div>
  );
}
